if(!customElements.get('custom-featured-blog-posts')){
    class CustomFeaturedBlogPosts extends HTMLElement {
        constructor(){
            super();

            this._onSwitchBlogClick = this.switchBlog.bind(this);
            this._onSwitchBlogKeydown = (event) => {
                if(event.key === "Enter"){
                    this.switchBlog(event);
                }
            };
            this._onPrevClick = this.toPrevPage.bind(this);
            this._onPrevKeydown = (event) => {
                if(event.key === 'Enter'){
                    this.toPrevPage(event);
                }
            };
            this._onNextClick = this.toNextPage.bind(this);
            this._onNextKeydown = (event) => {
                if(event.key === 'Enter'){
                    this.toNextPage(event);
                }
            };
            this._onEllipsisClick = this.openBlogList.bind(this);
            this._onEllipsisKeydown = (event) => {
                if(event.key === 'Enter'){
                    this.openBlogList(event);
                }
            };

            this.init();
        }

        init(){
            if(this.navigations){
                this.navigations.forEach(item => {
                    item.removeEventListener('click', this._onSwitchBlogClick);
                    item.removeEventListener('keydown', this._onSwitchBlogKeydown);
                });
            }
            if(this.prevBtns){
                this.prevBtns.forEach(item => {
                    item.removeEventListener('click', this._onPrevClick);
                    item.removeEventListener('keydown', this._onPrevKeydown);
                });
            }
            if(this.nextBtns){
                this.nextBtns.forEach(item => {
                    item.removeEventListener('click', this._onNextClick);
                    item.removeEventListener('keydown', this._onNextKeydown);
                });
            }
            if(this.ellipsisBtn){
                this.ellipsisBtn.removeEventListener('click', this._onEllipsisClick);
                this.ellipsisBtn.removeEventListener('keydown', this._onEllipsisKeydown);
            }

            this.navigations = this.querySelectorAll('.featured-blog-posts__navigation');
            this.articles = this.querySelectorAll('.featured-blog-posts__articles');
            this.navigations.forEach(item => {
                item.addEventListener('click', this._onSwitchBlogClick);
                item.addEventListener("keydown", this._onSwitchBlogKeydown);
            })

            this.prevBtns = this.querySelectorAll('.posts-navigation__prev');
            this.prevBtns.forEach(item => {
                item.addEventListener('click', this._onPrevClick);
                item.addEventListener('keydown', this._onPrevKeydown);
            });

            this.nextBtns = this.querySelectorAll('.posts-navigation__next');
            this.nextBtns.forEach(item => {
                item.addEventListener('click', this._onNextClick);
                item.addEventListener('keydown', this._onNextKeydown);
            });

            this.ellipsisBtn = this.querySelector('.featured-blog-posts__navigation-icon');
            this.ellipsisBtn.addEventListener('click', this._onEllipsisClick);
            this.ellipsisBtn.addEventListener('keydown', this._onEllipsisKeydown);

            this.blog = this.querySelector('.featured-blog-posts-blogs');

            this.navigationWrapper = this.querySelector('.featured-blog-posts__navigations');
            this.contentWrapper = this.querySelector('.featured-blog-posts__content');

            this.adjustMinHeight();

            this.lastWidth = window.innerWidth;

            // Remove any previously bound handler before re-adding so refresh()/init()
            // can't stack multiple resize listeners on window (which would re-run
            // adjustMinHeight several times per resize).
            if(this.onResize){
                window.removeEventListener('resize', this.onResize);
            }
            this.onResize = () => {
                const currentWidth = window.innerWidth;

                // Only recompute on an actual width change. Updating lastWidth here
                // is what makes the guard work — otherwise it stays stale and fires
                // on every resize, including mobile address-bar/height-only changes.
                if(currentWidth !== this.lastWidth){
                    this.lastWidth = currentWidth;
                    this.adjustMinHeight();
                }
            };
            window.addEventListener('resize', this.onResize, false);
        }

        adjustMinHeight(){
            if(window.innerWidth > 1200){
                this.navigationWrapper.style.minHeight = 'unset';
                this.contentWrapper.style.minHeight = 'unset';

                return;
            }

            this.navigationWrapper.style.minHeight = '';
            this.contentWrapper.style.minHeight = '';

            let contents = this.contentWrapper.querySelectorAll('.featured-blog-posts__article-content');
            let bgImages = this.querySelectorAll('.featured-blog-posts__article-image');

            let minHeight = 0;
            contents.forEach(item => {
                item.closest('.featured-blog-posts__articles').classList.add('d-block');
                let itemHeight = item.offsetHeight;
                item.closest('.featured-blog-posts__articles').classList.remove('d-block');
                if(itemHeight > minHeight){
                    minHeight = itemHeight;
                }
            })

            if(bgImages.length > 0){
                minHeight += bgImages[0].offsetHeight;
            }

            this.navigationWrapper.style.minHeight = `${minHeight}px`;
            this.contentWrapper.style.minHeight = `${minHeight}px`;
        }

        switchBlog(e){
            const currentBlog = e.currentTarget;
            const currentBlogIdx = currentBlog.dataset.idx;

            this.navigations.forEach(item => {
                item.classList.remove('active');
            })
            currentBlog.classList.add('active');

            this.articles.forEach(item => {
                var articleIdx = item.dataset.idx;

                if(articleIdx ===  currentBlogIdx){
                    item.setAttribute('data-active', 'true');
                }else{
                    item.setAttribute('data-active', 'false');

                    // reset index
                    item.querySelectorAll('.featured-blog-posts__article-content').forEach(i => {
                        if(i.dataset.articleIdx === '1'){
                            i.setAttribute('data-initial-article', 'true');
                        }else{
                            i.setAttribute('data-initial-article', 'false');
                        }
                    })
                }
            })

            this.closeBlogList();
            this.updateActiveIndex(currentBlogIdx);
        }

        openBlogList(){
            this.blog.setAttribute('aria-hidden', 'false');

            this.navigations.forEach(item => {
                item.classList.remove('active');
            })
        }

        closeBlogList(){
            this.blog.setAttribute('aria-hidden', 'true');
        }

        toPrevPage(e){
            var currentArticle = e.currentTarget.closest('.featured-blog-posts__article-content');
            var currentArticleWrapper = currentArticle.closest('.featured-blog-posts__article-content-wrapper');
            var currentArticleIdx = parseInt(currentArticle.dataset.articleIdx);
            var nextArticleIdx = currentArticleIdx - 1;
            var currentArticles = currentArticle.closest('.featured-blog-posts__articles');
            var currentArticleImageWrapper = currentArticles.querySelector('.featured-blog-posts__article-image-wrapper');

            currentArticleWrapper.querySelectorAll('.featured-blog-posts__article-content').forEach(item => {
                var itemIdx = parseInt(item.dataset.articleIdx);

                if(itemIdx === nextArticleIdx){
                    item.setAttribute('data-initial-article', 'true');
                }else{
                    item.setAttribute('data-initial-article', 'false');
                }
            })

            currentArticleImageWrapper.querySelectorAll('.featured-blog-posts__article-image').forEach(item => {
                var itemIdx = parseInt(item.dataset.articleIdx);

                if(itemIdx === nextArticleIdx){
                    item.setAttribute('data-initial-article', 'true');
                }else{
                    item.setAttribute('data-initial-article', 'false');
                }
            })
        }

        toNextPage(e){
            var currentArticle = e.currentTarget.closest('.featured-blog-posts__article-content');
            var currentArticleWrapper = currentArticle.closest('.featured-blog-posts__article-content-wrapper');
            var currentArticleIdx = parseInt(currentArticle.dataset.articleIdx);
            var nextArticleIdx = currentArticleIdx + 1;
            var currentArticles = currentArticle.closest('.featured-blog-posts__articles');
            var currentArticleImageWrapper = currentArticles.querySelector('.featured-blog-posts__article-image-wrapper');

            currentArticleWrapper.querySelectorAll('.featured-blog-posts__article-content').forEach(item => {
                var itemIdx = parseInt(item.dataset.articleIdx);

                if(itemIdx === nextArticleIdx){
                    item.setAttribute('data-initial-article', 'true');
                }else{
                    item.setAttribute('data-initial-article', 'false');
                }
            })

            currentArticleImageWrapper.querySelectorAll('.featured-blog-posts__article-image').forEach(item => {
                var itemIdx = parseInt(item.dataset.articleIdx);

                if(itemIdx === nextArticleIdx){
                    item.setAttribute('data-initial-article', 'true');
                }else{
                    item.setAttribute('data-initial-article', 'false');
                }
            })
        }

        updateActiveIndex(idx){
            this.setAttribute('data-active-idx', idx);
        }

        refresh(){
            this.init();
        }
    }

    customElements.define('custom-featured-blog-posts', CustomFeaturedBlogPosts);
}
